<template>
  <div id="login" class="column is-full-mobile is-three-fifths-tablet is-4-desktop is-4-widescreen is-4-fullhd is-offset-one-fifth-tablet is-offset-4-desktop is-offset-4-widescreen is-offset-4-fullhd">
    <div class="box">
      <div class="columns">
        <div class="column is-full">
          <img src="../assets/images/logo-pneudart-blue.svg" alt="Pneu-Dart" class="column is-10-mobile is-offset-1-mobile is-8-tablet is-offset-2-tablet is-inline-block">
          <p class="is-size-6 has-text-primary has-text-centered">Channel Partner Product Request System</p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <div v-if="displayLoggedOutNotification" class="notification is-success">
            You have been successfully logged out.
          </div>
          <div v-if="displaySessionExpiredNotification" class="notification is-danger">
            Your session expired. Please login.
          </div>
          <form v-on:submit.prevent="login">
            <b-field label="Username" horizontal
              :type="getFieldTypesFromValidationPath('email')"
              :message="getFieldMessages('email')">
              <b-input type="email" name="email" v-model.trim="$v.email.$model" :loading="$wait.is([])" :disabled="$wait.any" @input.native="set" autocomplete="email username"></b-input>
            </b-field>
            <b-field label="Password" horizontal
              :type="getFieldTypesFromValidationPath('password')"
              :message="getFieldMessages('password')">
              <b-input type="password" name="password" v-model.trim="$v.password.$model" :loading="$wait.is([])" :disabled="$wait.any" @input.native="set" password-reveal autocomplete="password"></b-input>
            </b-field>
            <b-field horizontal>
              <nav class="level">
                <div class="level-left">
                  <div class="level-item">
                    <b-button native-type="submit" type="is-primary" :class="{ 'is-loading-inline': $wait.is('logging in') }">
                        <template v-if="$wait.is('authenticating')">Authenticating...</template>
                        <template v-if="$wait.is(['getting subsidiaries','getting itemFilterGroups','getting itemTags','getting items'])">Loading User Information...</template>
                        <template v-if="$wait.is(['getting priceDiscountGroupsToPriceDiscountLevels'])">Loading Interface...</template>
                        <template v-if="! $wait.any">Login</template>
                    </b-button>
                  </div>
                </div>
                <div v-if="! $wait.is('logging in')" class="level-item">
                  <p class="control">
                    <a @click="toggleForgotPasswordModal(true)">Forgot Password</a>
                  </p>
                </div>
              </nav>
            </b-field>
          </form>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isForgotPasswordModalActive" class="forgot-password-modal" has-modal-card trap-focus>
      <forgot-password-modal></forgot-password-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { validations, messages } from '@/plugins/vuelidate/validations/login'

import ForgotPasswordModal from '@/components/ForgotPasswordModal'

export default {
  data: function () {
    return {
      email: '',
      password: '',
      messages: messages,
      apiValidationErrors: {},
      isForgotPasswordModalActive: false
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'customer',
      'itemTags'
    ]),
    packageItemTag () {
      return this.getItemTagByName('Package')
    },
    isDomesticCustomer () {
      return ['DOMESTIC'].includes(this.customer.geographical_restriction)
    },
    isCanadianCustomer() {
      return ['CANADIAN'].includes(this.customer.geographical_restriction)
    },
    isInternationalCustomer () {
      return ['INTERNATIONAL'].includes(this.customer.geographical_restriction)
    },
    loginRedirect () {
      return (this.$route.query.r) ? window.atob(this.$route.query.r) : '/'
    },
    isLoggedOut () {
      return ! this.token && this.$route.query.hasOwnProperty('logout')
    },
    isSessionExpired () {
      return ! this.token && this.$route.query.r
    },
    displayLoggedOutNotification () {
      return ! this.$wait.is(['logging in']) && this.isLoggedOut
    },
    displaySessionExpiredNotification () {
      return ! this.$wait.is(['logging in']) && this.isSessionExpired
    },
    loginLoader () {
      return 'logging in'
    },
    loginPathSubset () {
      return ['email', 'password']
    },
    loginPropertySubset () {
      return this.getPropertiesFromPaths(this.loginPathSubset)
    },
    isSaving () {
      return this.$wait.any
    },
  },
  validations: validations,
  components: {
    ForgotPasswordModal
  },
  methods: {
    ...mapActions([
      'authenticate',
      'deauthenticate',
      'getSubsidiaries',
      'getItemFilterGroups',
      'getItems',
      'getItemTags',
      'getPriceDiscountGroupsToPriceDiscountLevels',
      'getPreviousYearChannelPartnerCommitmentVsShipped',
      'getYearToDateChannelPartnerCommitmentVsShipped',
      'getOrderItemsPlaced',
      'getCommission',
      'sendPasswordResetLinkEmail'
    ]),
    getItemTagByName (itemTagName) {
      return this.itemTags.find((itemTag) => itemTag.item_tag_name === itemTagName)
    },
    set (e) {
      this.clearApiValidationFailures(e.target.name)
    },
    failedApiValidation (property) {
      return this.apiValidationErrors.hasOwnProperty(property)
    },
    clearApiValidationFailures (property) {
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        delete this.apiValidationErrors[property]
      }
    },
    getFieldTypesFromValidationPath (validationPath) {
      return {
        'is-danger': eval(`this.$v.${ validationPath }.$error`)
      }
    },
    getFieldMessages(validationPath) {
      let validationPathArray = validationPath.split('.')
      return {...this.getFieldMessagesFromValidationPath(validationPath), ...this.getFieldMessagesFromFailedApiValidation(validationPathArray.pop())}
    },
    getFieldMessagesFromFailedApiValidation (property) {
      let fieldMessages = {}
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        fieldMessages[this.apiValidationErrors[property]] = true
      }
      return fieldMessages
    },
    getFieldMessagesFromValidationPath (validationPath) {
      let validationPathArray = validationPath.split('.')
      let messages = this.messages

      while (validationPathArray.length) {
        messages = messages[validationPathArray.shift()]
      }

      let fieldMessages = {}

      for (const validation in messages) {
        fieldMessages[messages[validation]] = eval(`this.$v.${ validationPath }.$error && ! this.$v.${ validationPath }.${ validation }`)
      }

      return fieldMessages
    },
  toggleForgotPasswordModal (display) {
    this.isForgotPasswordModalActive = display
  },
    isValid (pathSubset) {
      let invalid = false
      for(const path of pathSubset) {
        eval(`this.$v.${ path }.$touch()`)
        invalid = invalid || eval(`this.$v.${ path }.$invalid`)
      }
      if (invalid) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    validate (pathSubset) {
      if (! this.isValid(pathSubset)) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    async login (e) {
      if (this.isValid(this.loginPathSubset)) {
        this.$wait.start(this.loginLoader)
        const form = new FormData(e.currentTarget)
        try {
          await this.authenticate({
            data: form, 
          })
          await this.getSubsidiaries({
            sort: [
              'subsidiary_name'
            ],
          })
          await this.getItemFilterGroups({
            includes: [
              'itemFilters',
              'itemFilters.itemTags',
              'itemFiltersToItemFilterGroups',
              'itemFiltersToItemFilterGroups.childItemFilterGroup',
            ]
          }),
          await this.getItemTags({})
          await this.getItems({
            filters: {
              excludeItemTagIds: [
                (this.packageItemTag) ? this.packageItemTag.id : null,
              ].join(',')
            },
            includes: [
              'itemTags',
            ]
          })
          await this.getPriceDiscountGroupsToPriceDiscountLevels({})
          // await this.getPreviousYearChannelPartnerCommitmentVsShipped({})
          // await this.getYearToDateChannelPartnerCommitmentVsShipped({})
          await this.getOrderItemsPlaced({})
          // await this.getCommission({})
          this.$wait.end(this.loginLoader)
          this.$router.push(this.loginRedirect)
          return true
        } catch (error) {
          console.log(error)
          this.$wait.end(this.loginLoader)
          this.$buefy.dialog.alert({
            type: 'is-danger',
            title: 'Error',
            message: 'Invalid credentials. Please try again.',
          })
          return false
        }
      }
    }
  },
  errorCaptured: (err) => {
    alert(err)
  },
  mounted () {
    if (this.$route.query.hasOwnProperty('logout')) {
      this.deauthenticate()
    }
  }

}
</script>